import { stateList, AusState } from './constant';

export const getstateList = (env) => {
  switch (env) {
    case 'development':
      return stateList;
    case 'stage':
      return stateList;
    case 'production':
      return stateList;
    case 'au_development':
      return AusState;
    case 'au_stage':
      return AusState;
    case 'au_production':
      return AusState;
    default:
      return AusState;
  }
};

const AusCoutry = [{ value: 'Austalia', label: 'Austalia' }];
const UsaCoutry = [{ value: 'USA', label: 'USA' }];

export const getCountry = (env) => {
  switch (env) {
    case 'development':
      return UsaCoutry;
    case 'stage':
      return UsaCoutry;
    case 'production':
      return UsaCoutry;
    case 'au_development':
      return AusCoutry;
    case 'au_stage':
      return AusCoutry;
    case 'au_production':
      return AusCoutry;
    default:
      return AusCoutry;
  }
};

export const formatDateForPayload = (dateString, env) => {
  if (!dateString) return dateString;

  const date = new Date(dateString);
  const isUS = ['development', 'stage', 'production'].includes(env);

  if (isUS) {
    // MM/dd/yyyy format
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } else {
    // dd/MM/yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
};

export const parseDateFromPayload = (dateString, env) => {
  if (!dateString) return '';

  const usEnvironments = ['development', 'stage', 'production'];
  const isUS = usEnvironments.includes(env);

  let day, month, year;

  if (isUS) {
    // Parse MM/dd/yyyy format
    const parts = dateString.split('/');
    if (parts.length !== 3) return dateString; // Return as-is if format is unexpected

    month = parts[0];
    day = parts[1];
    year = parts[2];
  } else {
    // Parse dd/MM/yyyy format
    const parts = dateString.split('/');
    if (parts.length !== 3) return dateString; // Return as-is if format is unexpected

    day = parts[0];
    month = parts[1];
    year = parts[2];
  }

  const paddedMonth = month.padStart(2, '0');
  const paddedDay = day.padStart(2, '0');

  return `${year}-${paddedMonth}-${paddedDay}`;
};
